import React, { useState } from 'react';
import { 
  Users,
  User,
  Building,
  Phone,
  Mail,
  Calendar,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Clock,
  Eye,
  Trash2,
  Download,
  Plus,
  Edit,
  Save,
  X,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Shield,
  Lock,
  Key,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Globe,
  Users2,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart,
  AreaChart,
  TrendingUp,
  TrendingDown,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon2,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon2,
  CheckCircle as CheckCircleIcon2,
  XCircle as XCircleIcon2,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon2,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const CRMIntegration = () => {
  const [activeTab, setActiveTab] = useState('customers');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for customers
  const [customers, setCustomers] = useState([
    {
      id: 'CUST-001',
      customerName: 'Acme Corporation',
      customerCode: 'ACME001',
      industry: 'Technology',
      status: 'Active',
      contactPerson: 'John Smith',
      email: 'john.smith@acme.com',
      phone: '+1-555-0123',
      address: '123 Business Ave, Tech City, CA 94000',
      totalContracts: 8,
      totalValue: '$2,500,000.00',
      lastInteraction: '2024-02-15',
      customerSince: '2020-03-15',
      isActive: true,
      tags: ['enterprise', 'technology', 'high-value'],
      isBookmarked: true,
      isStarred: true,
      viewCount: 234,
      downloadCount: 15,
      aiInsights: ['High-value customer', 'Strong contract portfolio', 'Regular interactions'],
      keyMetrics: {
        averageContractValue: '$312,500',
        contractRenewalRate: '95%',
        satisfactionScore: '4.8/5.0',
        responseTime: '2 hours'
      },
      alerts: ['Contract renewal due'],
      performanceScore: 94.2
    },
    {
      id: 'CUST-002',
      customerName: 'Global Manufacturing Ltd',
      customerCode: 'GML002',
      industry: 'Manufacturing',
      status: 'Active',
      contactPerson: 'Sarah Johnson',
      email: 'sarah.j@globalmfg.com',
      phone: '+1-555-0456',
      address: '456 Industrial Blvd, Manufacturing City, TX 75000',
      totalContracts: 12,
      totalValue: '$1,800,000.00',
      lastInteraction: '2024-02-14',
      customerSince: '2019-08-20',
      isActive: true,
      tags: ['manufacturing', 'enterprise', 'reliable'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 189,
      downloadCount: 12,
      aiInsights: ['Stable customer relationship', 'Consistent contract volume', 'Good payment history'],
      keyMetrics: {
        averageContractValue: '$150,000',
        contractRenewalRate: '92%',
        satisfactionScore: '4.6/5.0',
        responseTime: '4 hours'
      },
      alerts: [],
      performanceScore: 88.7
    },
    {
      id: 'CUST-003',
      customerName: 'StartupTech Inc',
      customerCode: 'ST003',
      industry: 'Technology',
      status: 'Prospect',
      contactPerson: 'Mike Wilson',
      email: 'mike@startuptech.com',
      phone: '+1-555-0789',
      address: '789 Innovation St, Startup Hub, CA 94100',
      totalContracts: 2,
      totalValue: '$150,000.00',
      lastInteraction: '2024-02-10',
      customerSince: '2024-01-15',
      isActive: true,
      tags: ['startup', 'technology', 'growing'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 67,
      downloadCount: 5,
      aiInsights: ['Growing startup', 'Potential for expansion', 'Early stage relationship'],
      keyMetrics: {
        averageContractValue: '$75,000',
        contractRenewalRate: '100%',
        satisfactionScore: '4.9/5.0',
        responseTime: '1 hour'
      },
      alerts: ['Follow-up required'],
      performanceScore: 76.3
    }
  ]);

  // Mock data for sales pipeline
  const [salesPipeline, setSalesPipeline] = useState([
    {
      id: 'OPP-001',
      opportunityName: 'Enterprise Software License',
      customer: 'Acme Corporation',
      stage: 'Proposal',
      value: '$500,000.00',
      probability: 75,
      expectedCloseDate: '2024-03-15',
      assignedTo: 'Sales Rep A',
      createdDate: '2024-01-15',
      lastActivity: '2024-02-15',
      isActive: true,
      tags: ['enterprise', 'software', 'high-value'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 45,
      downloadCount: 8,
      aiInsights: ['Strong opportunity', 'Good probability', 'Timeline realistic'],
      keyMetrics: {
        daysInStage: 31,
        averageStageTime: '45 days',
        winRate: '75%',
        competitorAnalysis: 'Low competition'
      },
      alerts: ['Follow-up scheduled'],
      performanceScore: 85.6
    },
    {
      id: 'OPP-002',
      opportunityName: 'Cloud Infrastructure Services',
      customer: 'Global Manufacturing Ltd',
      stage: 'Negotiation',
      value: '$250,000.00',
      probability: 60,
      expectedCloseDate: '2024-02-28',
      assignedTo: 'Sales Rep B',
      createdDate: '2024-01-20',
      lastActivity: '2024-02-14',
      isActive: true,
      tags: ['cloud', 'infrastructure', 'manufacturing'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 32,
      downloadCount: 6,
      aiInsights: ['Negotiation in progress', 'Price discussions ongoing', 'Technical requirements met'],
      keyMetrics: {
        daysInStage: 25,
        averageStageTime: '30 days',
        winRate: '60%',
        competitorAnalysis: 'Medium competition'
      },
      alerts: ['Price negotiation active'],
      performanceScore: 72.4
    }
  ]);

  // Calculate statistics
  const stats = {
    totalCustomers: customers.length,
    activeCustomers: customers.filter(c => c.status === 'Active').length,
    prospectCustomers: customers.filter(c => c.status === 'Prospect').length,
    totalCustomerValue: customers.reduce((sum, customer) => {
      const value = parseFloat(customer.totalValue.replace(/[$,]/g, ''));
      return sum + value;
    }, 0),
    totalOpportunities: salesPipeline.length,
    totalPipelineValue: salesPipeline.reduce((sum, opp) => {
      const value = parseFloat(opp.value.replace(/[$,]/g, ''));
      return sum + value;
    }, 0),
    averageDealSize: salesPipeline.reduce((sum, opp) => {
      const value = parseFloat(opp.value.replace(/[$,]/g, ''));
      return sum + value;
    }, 0) / salesPipeline.length,
    averageProbability: salesPipeline.reduce((sum, opp) => sum + opp.probability, 0) / salesPipeline.length
  };

  const tabs = [
    { id: 'customers', label: 'Customer Management' },
    { id: 'sales-pipeline', label: 'Sales Pipeline' },
    { id: 'interactions', label: 'Customer Interactions' },
    { id: 'analytics', label: 'CRM Analytics' }
  ];

  // Define columns for Customer Management DataTable
  const customerManagementColumns = [
    {
      key: 'customerName',
      label: 'Customer Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.customerCode} • {row.industry}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5' },
          'Prospect': { color: '#f59e0b', bg: '#fef3c7' },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6' },
          'Suspended': { color: '#ef4444', bg: '#fee2e2' }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {status}
          </span>
        );
      }
    },
    {
      key: 'contactPerson',
      label: 'Contact Person',
      width: '150px',
      render: (person) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{person}</span>
      )
    },
    {
      key: 'totalContracts',
      label: 'Contracts',
      width: '100px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{count}</span>
      )
    },
    {
      key: 'totalValue',
      label: 'Total Value',
      width: '120px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{value}</span>
      )
    },
    {
      key: 'lastInteraction',
      label: 'Last Interaction',
      width: '140px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'customerSince',
      label: 'Customer Since',
      width: '140px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Customer"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Customer"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for Sales Pipeline DataTable
  const salesPipelineColumns = [
    {
      key: 'opportunityName',
      label: 'Opportunity Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.customer} • {row.assignedTo}
          </div>
        </div>
      )
    },
    {
      key: 'stage',
      label: 'Stage',
      width: '120px',
      render: (stage) => {
        const stageConfig = {
          'Lead': { color: '#6b7280', bg: '#f3f4f6' },
          'Qualified': { color: '#3b82f6', bg: '#dbeafe' },
          'Proposal': { color: '#f59e0b', bg: '#fef3c7' },
          'Negotiation': { color: '#8b5cf6', bg: '#ede9fe' },
          'Closed Won': { color: '#10b981', bg: '#d1fae5' },
          'Closed Lost': { color: '#ef4444', bg: '#fee2e2' }
        };
        const config = stageConfig[stage] || stageConfig['Lead'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {stage}
          </span>
        );
      }
    },
    {
      key: 'value',
      label: 'Value',
      width: '120px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{value}</span>
      )
    },
    {
      key: 'probability',
      label: 'Probability',
      width: '120px',
      render: (probability) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${Math.min(probability, 100)}%`,
              height: '100%',
              backgroundColor: probability >= 70 ? '#10b981' : probability >= 40 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: probability >= 70 ? '#10b981' : probability >= 40 ? '#f59e0b' : '#ef4444' 
          }}>
            {probability}%
          </span>
        </div>
      )
    },
    {
      key: 'expectedCloseDate',
      label: 'Expected Close',
      width: '140px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'assignedTo',
      label: 'Assigned To',
      width: '120px',
      render: (assigned) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{assigned}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Opportunity"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Opportunity"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.customerName || item.opportunityName);
  };

  const handleExport = (item) => {
    setSelectedItem(item);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'customers') {
        setCustomers(prev => prev.filter(customer => customer.id !== selectedItem.id));
      } else {
        setSalesPipeline(prev => prev.filter(opp => opp.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          CRM Integration
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Manage customer relationships and sales pipeline with integrated CRM systems
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'customers' && <Users size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'sales-pipeline' && <Target size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'interactions' && <MessageSquare size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'analytics' && <BarChart size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Customers</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalCustomers}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeCustomers} active, {stats.prospectCustomers} prospects
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <Users size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Customer Value</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalCustomerValue / 1000000).toFixed(1)}M
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Customer portfolio value
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <DollarSignIcon size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Sales Pipeline</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.totalOpportunities}
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Active opportunities
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <Target size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Pipeline Value</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalPipelineValue / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.averageProbability.toFixed(0)}% avg probability
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ef444420',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ef4444'
          }}>
            <TrendingUp size={20} />
          </div>
        </div>
      </div>

      {/* Customer Management Tab */}
      {activeTab === 'customers' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={customers}
              columns={customerManagementColumns}
              title={`Customer Management (${customers.length} customers)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Sales Pipeline Tab */}
      {activeTab === 'sales-pipeline' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={salesPipeline}
              columns={salesPipelineColumns}
              title={`Sales Pipeline (${salesPipeline.length} opportunities)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'interactions' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Customer Interactions Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'analytics' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          CRM Analytics Dashboard Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Item"
        message={`Are you sure you want to delete "${selectedItem?.customerName || selectedItem?.opportunityName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export CRM report for "${selectedItem?.customerName || selectedItem?.opportunityName}"? This will generate a comprehensive report with customer details and sales information.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default CRMIntegration;
